<template>
  <div class="zodiac-people-wrapper px-8">
    <div class="slide-deck-wrapper relative pt-20 px-8 pb-8">
      <img src="@/assets/images/bg/news-frame.svg" class="frame-backward absolute inset-0">
      <swiper class="swiper" :options="swiperOption">
        <template v-for="post in zodiacPeopleList">
          <swiper-slide v-if="post.featured" :data-swiper-autoplay="calcSlideInterval(post.slide_interval)"
            :key="post.id">
            <section class="zodiac-people--post flex flex-col h-full">
              <img class="post-cover" :src="$zodiac.makeUrl(post.photo && post.photo.url)" :alt="post.title">
              <h3 class="post-title text-white text-3xl font-medium">{{post.title}}</h3>
            </section>
          </swiper-slide>
        </template>
      </swiper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  /* eslint-disable no-unused-vars */
  components: {
  },
  created() {
  },
  data() {
    return {
    }
  },
  methods: {
    calcSlideInterval(itv) {
      const res = (itv || this.zodiacPeopleConfig.autoslide_interval || 20)
      return res * 1000
    },
  },
  computed: {
    ...mapGetters([
      'zodiacPeopleConfig',
      'zodiacPeopleList',
    ]),
    swiperOption() {
      if(this.zodiacPeopleConfig && this.zodiacPeopleConfig.autoslide_interval) {
        const { autoslide_interval, default_transition, loop } = this.zodiacPeopleConfig
        const config = {
          effect: default_transition,
          fadeEffect: {
            crossFade: true
          },
          // centeredSlides: true,
          loop: false,
          speed: 500,
          autoplay: {
            enabled: autoslide_interval > 0,
            delay: autoslide_interval * 1000,
            disableOnInteraction: false,
            pauseOnMouseEnter: false
          },
        }
        return config
      }
      return null
    },
  }
}
</script>

<style>
.zodiac-people-wrapper, .zodiac-people-wrapper * {
  min-height: 0;
}
.zodiac-people-wrapper > * {
  height: 100%;
}
.zodiac-people-wrapper .frame-backward {
  top: 0px;
  right: 0px;
  bottom: auto;
  left: 0px;
  height: 100%;
  width: 100%;
}
.slide-deck-wrapper > .swiper {
  height: 100%;
}
.zodiac-people--post > .post-cover {
  min-height: 0;
  height: calc(100% - 5rem);
  object-fit: cover;
}
.zodiac-people--post > .post-title {
  margin-top: .5rem;
  height: 4.5rem;
}
</style>
